import React from 'react';
import { GameIcon } from '../../icons/GameIcon';
import { gql } from '@urql/core';
import { PlayerCardRankFragment } from '../../../generated/spin-graphql';

type Props = {
    className?: string;
    player: PlayerCardRankFragment;
};

gql`
    fragment PlayerCardRank on espin_player_profile {
        primary_game: player_games(where: { primary: { _eq: true } }) {
            game {
                name
                game_definition
            }
            rank
        }
    }
`;

export const PlayerCardRank: React.FC<Props> = ({ className, player }) => {
    if (player.primary_game.length === 0) {
        return <></>;
    }
    const {
        game: { game_definition, name },
        rank,
    } = player.primary_game[0];

    return (
        <div className="player-rank-display">
            <GameIcon game={game_definition} gameName={name} />
            <div className="player-rank">
                <p className="rank-label">RANK</p>
                <p className="rank">{rank}</p>
            </div>
        </div>
    );
};
